module.exports = "https://www.gc-pro.gnp.com.mx/5b28183be146590cf9368f20b8c919a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/datos-personales.svg
// module id = 1813
// module chunks = 0